export default {
  methods: {
    getPaymentBranchLedgers () {
      this.$axios
      .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
      .then((data) => {
        this.payment_ledgers = data.data
        $.each(this.payment_ledgers, function (key, value) {
          this.payment_ledgers[key].name = value.ledger.name
          if (value.ledger.id === 3) {
            this.form.branch_ledger_id = value.id
          }
        }.bind(this))
      }).catch(function (error) { console.log(error) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PaymentBranchLedgers.js